import React from "react";
import { SuperBlockContent } from "./super-block-content";

import "./flex.scss";
import classNames from "classnames";

interface Props {
  maxColumns?: number;
  maxWidth?: number;
  minWidth?: number;
  spacing?: string;
  align?: string;
  color?: string;
  body?: any[];
}

export const Flex = ({
  body,
  maxColumns,
  maxWidth,
  spacing,
  align,
  color,
}: Props) => {
  return (
    <div className="">
      <SuperBlockContent
        projectId={"g3so7nt7"}
        dataset={"production"}
        className={classNames(
          "flex--container",
          `flex--container--${spacing}`,
          `flex--container--align--${align}`,
          `flex--container--color--${color}`,
        )}
        blocks={body}
      />
    </div>
  );
};
